<template>
  <div>
    <div
      class="parent"
      :style="style"
      :class="[!showDetails ? 'parent-2' : '']"
    >
      <v-card @click="showReceiptfun">
        <div class="right-side">
          <div class="rotated">{{ receipt.TypeName }}</div>
        </div>
        <div class="left-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ receipt.Title }}
            </div>
          </v-card-title>
          <div>
            <app-row
              icon="calendar-alt"
              title="تاریخ:"
              :value="receipt.Tarikh"
            />
            <app-row icon="money-bill" title="مبلغ:" :value="daryafti" />
            <app-row icon="building" title="بانک:" :value="receipt.BankName" />
            <app-row
              icon="hashtag"
              title="شبا:"
              :value="receipt.ShomareHesab"
            />
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["receipt", "index", "selectedReceipt", "showDetails"],
  components: {
    appRow: DetailRow,
  },
  /**
   * open hozoor list
   */
  methods: {
    showReceiptfun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
  computed: {
    daryafti() {
      var number = this.receipt.Daryafti;
      const locale = Math.abs(Number(number)).toLocaleString();
      return locale + (number < 0 ? "-" : "") + " ریال";
    },
    style() {
      var res = "";
      if (this.showDetails) {
        if (this.$store.getters.isMobile) {
          res = "width: 100%";
        } else {
          res = "width: calc(100% - 300px)";
        }
      }
      return res;
    },
  },
  created() {},
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 0px 0px 0px !important;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
</style>
